module.exports = __webpack_public_path__ + "static/img/MidPlate-RA.9122428.png";